var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message_action_container" },
    [
      _c(
        "div",
        {
          staticClass: "title_message",
          class: [_vm.hideAction ? "hide_action" : ""]
        },
        [
          _vm._t("above-message"),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.message))])
        ],
        2
      ),
      _vm._v(" "),
      !_vm.hideAction
        ? _c(
            "ns-button",
            {
              staticClass: "message_action",
              attrs: {
                fluid: _vm.$mq !== "desktop" && _vm.$mq !== "desktopHD",
                theme: "secondary-outline"
              },
              on: { click: _vm._messageAction }
            },
            [_vm._v(_vm._s(_vm.actionName))]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hideSecondaryAction
        ? _c(
            "ns-button",
            {
              staticClass: "secondary_message_action",
              attrs: {
                fluid: _vm.$mq !== "desktop" && _vm.$mq !== "desktopHD",
                theme: "secondary"
              },
              on: { click: _vm._secondaryMessageAction }
            },
            [_vm._v(_vm._s(_vm.secondaryActionName))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "below-action" }, [_vm._t("below-action")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }